"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exercism = void 0;
var types_1 = require("../types");
exports.exercism = {
    name: 'exercism',
    matches: [
        {
            match: '(https?://)?(www.)?exercism.io/profiles/({PROFILE_ID})/?', group: 3, type: types_1.TYPE_DESKTOP,
            pattern: 'https://exercism.io/profiles/{PROFILE_ID}'
        },
        { match: '({PROFILE_ID})', group: 1 },
    ]
};
//# sourceMappingURL=exercism.js.map